import graphql from './graphql';

const query = /* GraphQL */ `
  query Department_listWithCounts {
    Department_listWithCounts {
      id
      name
      status
      numberOfEmployees
      numberOfCourses
    }
  }
`;

const DepartmentListWithCounts = async () => graphql(query).then(data => data?.Department_listWithCounts || []);

export default DepartmentListWithCounts;
